import React, { Component } from 'react';
import './AudioBar.scss';

class Scrubber extends Component {

  render() {
    return (
      <div className="scrubber">
        <div className="scrubber-progress">
          <div className="scrubber-control">
          </div>
        </div>
      </div>
    )
  }

}

export default Scrubber;